import { useQuery } from '@tanstack/react-query';
import { TokenAnalysisRequest, TokenAnalysisData } from '@crypto-trading/common/browser';
import * as tokenAnalysisApi from '@/api/tokenAnalysis';

const TOKEN_ANALYSIS_STALE_TIME_MS = 5 * 60 * 1000;

export const tokenAnalysisKeys = {
  all: ['token-analysis'] as const,
  detail: (
    tokenName: string,
    params?: Pick<TokenAnalysisRequest, 'exchange' | 'exchangeType' | 'currentPrice' | 'source'>
  ) =>
    [
      ...tokenAnalysisKeys.all,
      tokenName,
      params?.exchange ?? null,
      params?.exchangeType ?? null,
      params?.currentPrice ?? null,
      params?.source ?? null,
    ] as const,
};

interface UseTokenAnalysisParams {
  tokenName: string;
  exchange?: string;
  exchangeType?: string;
  currentPrice?: number;
  source?: string;
  telegramUserId?: string;
  enabled?: boolean;
}

export const useTokenAnalysis = ({
  tokenName,
  exchange,
  exchangeType,
  currentPrice,
  source,
  telegramUserId,
  enabled = true,
}: UseTokenAnalysisParams) => {
  const requestPayload: TokenAnalysisRequest = {
    exchange,
    exchangeType,
    currentPrice,
    source,
    telegramUserId,
  };

  return useQuery<TokenAnalysisData | null>({
    queryKey: tokenAnalysisKeys.detail(tokenName, requestPayload),
    queryFn: () => tokenAnalysisApi.getTokenAnalysis(tokenName, requestPayload),
    enabled: !!tokenName && enabled,
    staleTime: TOKEN_ANALYSIS_STALE_TIME_MS,
    retry: false,
  });
};


